module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAeCAYAAACMjVaFAAAAAXNSR0IArs4c6QAAAJdJREFUWEftmMEJwCAQBM9C0pEPW7AyW9AerCSVhAQi5LkgrGfW9+HezvgyxBjP3vthG53wlkopbVGr1mqjVCnFvBfLOZtKeXibMuXB0r2jTMkUkYCeHxE+FC1TEC7isEwR4UPRMgXhIg7LFBE+FC1TEC7isEwR4UPRMgXhIg7/xxQR8pTo1tr3M3PKrYtc8nw7L7LLtDUukQYaRwNJK7AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/sixteen-to-nine.png
// module id = UkIU
// module chunks = 3